var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSearch16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9068 10.4926C12.6404 9.48792 13.0684 8.24664 13.0559 6.90611C13.0248 3.59255 10.3134 0.927335 6.99981 0.953189C3.6862 0.979043 1.02518 3.68618 1.05624 6.99974C1.0873 10.3133 3.79869 12.9785 7.1123 12.9527C8.36273 12.9429 9.52024 12.5513 10.4752 11.8894L13.2929 14.7071L14.7071 13.2929L11.9068 10.4926ZM11.0559 6.92172C11.0766 9.13076 9.30262 10.9355 7.09355 10.9528C4.88448 10.97 3.07689 9.19318 3.05618 6.98413C3.03547 4.77509 4.80949 2.97034 7.01856 2.9531C9.22763 2.93587 11.0352 4.71268 11.0559 6.92172Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;